module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":""},"en":{"title":"Do you want to have a secure income from your unused land?"},"it":{"title":"Vuoi avere una rendita sicura da un tuo terreno inutilizzato?"},"lt":{"title":""},"pl":{"title":""},"es":{"title":"¿Quieres optimizar al máximo la rentabilidad de tu terreno?"}}')
  delete Component.options._Ctor
}
